<template>
  <div class="shopify_wrapper">
      <div class="header_warpper">
          <div class="left">
              <!-- <div class="logo"></div> -->
              <div class="title">{{$t('other.a406')}}{{$t('other.a545')}}</div>
              <div>{{$t('other.a546')}}</div>
          </div>
          <div class="right">
              <!-- <div class="shopifylogo"></div> -->
             <div class="desxc">{{$t('other.a547')}}</div>
          </div>
      </div>
      <div class="center">
          <div class="desc">
              <div class="item_desc">{{$t('other.a548')}}</div>
          </div>
          <div class="lvnkinvl">
              <div class="left">
                  <div class="imgBox"></div>
                  <div @click="getData()">{{$t('other.a548')}}</div>
              </div>

               <div class="right">
                  <div class="infign">{{$t('other.a549')}}：</div>
                  <div class="infign"><el-input v-model="userId" :placeholder="$t('other.a549')"></el-input></div>
                  <div class="kvnlkm"><el-button size="medium" type="primary" @click="remote()">{{$t('other.a550')}}</el-button></div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../src/api/moudles/shopaccess'
export default {
data(){
return{
    hasAccess:false,
    test:null,
    userId:null,
}
},
created(){
    
},
methods:{
    remote(){
        let url=location.href
        if(url.indexOf("?") > -1){
            let num=url.indexOf("?")
            let list=url.slice(num+1)
            let list2=list.split("&=")
            

            api
            .relevanceWeanalyUser({
                accessToken:list2[0],
                unionId:list2[1],
                weanalyUserId:list2[2],
                userId:this.userId

            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a475'))
            }else{
            this.$message.warning(res.msg)
            }
            })
            
        }
        
    },

    getData(){
        let url=location.href
        if(url.indexOf("?") > -1){
            let num=url.indexOf("?")
            let list=url.slice(num+1)
            let list2=list.split("&=")
            console.log(list)
            console.log(list.split("&="))

            api
            .getDXSAccount({
                accessToken:list2[0],
                unionId:list2[1],
                weanalyUserId:list2[2],
                

            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            
            }else{
            this.$message.warning(res.msg)
            }
            })
            
        }
    },
    
    goto(num){
        if(num == 0){
            this.$router.push('/index')
        }else if(num == 1){
             this.$router.push('/index')
        }else if(num == 2) {
            this.$router.push('/index')
        }else if(num == 3){
            this.$router.push('/index')
        }
    }

}
}

</script>
<style lang="scss" scoped>
.shopify_wrapper{
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;


    .vbfkh{
            color: rgb(0, 199, 163);
            font-size: 20px;
            margin-right: 15px;
        }

    .center{
        margin: 0 auto;
        width: 1200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;

        .lvnkinvl{
            display: flex;
            width: 450px;
            height: 300px;
            justify-content: space-between;
            align-items: center;
           


            .left{
                width: 150px;
            }


            .right{
                flex: 1;
                box-sizing: border-box;
                padding: 0 15px;

                .infign{
                    margin-bottom: 20px;
                }

                .kvnlkm{
                    text-align: right;
                }
            }
         
           
        }

        //  .lvnkinvl::before{
        //     content: '';
        //     width: 2px;
        //     height: 350px;
        //     background-color: #eeee;
        //     position: relative;
        //     left: 150px;
        // }

        .imgBox{
            background-image: url('../assets/img/h5_login.png');
            background-size: 100%;
            background-repeat: no-repeat;
            width: 120px;
            height: 120px;
        }

        .desc{
            display: flex;
            width: 450px;
            padding-bottom: 5px;
            border-bottom: 1px solid #eee;
            
            
            .item_desc{
                font-size: 25px;
                font-weight: bold;
                padding-right: 15px;
                cursor: pointer;
            }
        }

        


    }
    

    .header_warpper{
        margin: 0 auto;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        padding-bottom: 16px;
        border-bottom: 1px solid #606266;
       


        .left{
            display: flex;
            align-items: center;
            padding-top: 30px;
          

            .title{
                font-size: 25px;
                font-weight: bold;
                  color: #409eff;
            }

            .title::after{
                content:'|';
                color:#606266;
                padding:0 10px
            }

            .logo{
                width: 30px;
                height: 15px;
                
                background-size: 100%;
                background-repeat: no-repeat;;
                background-image: url('../assets/img/h5_login.png');
            }
        }


        .right{
            display: flex;
            
            align-items: center;

            .desxc{
                line-height: 75px;
                height: 50px;
                font-size: 20px;
                font-weight: bold;
            }
        }


        .shopifylogo{
            width: 260px;
            height: 75px;
            background-image: url('../assets/img/shopify.png');
            background-size: 100%;
            background-repeat: no-repeat;;
        }

    }
}
</style>